__turbopack_context__.v({
  "actionButton": "SocialMediaPopover-module-scss-module__cpyR_q__actionButton",
  "arrow": "SocialMediaPopover-module-scss-module__cpyR_q__arrow",
  "bottom": "SocialMediaPopover-module-scss-module__cpyR_q__bottom",
  "copySection": "SocialMediaPopover-module-scss-module__cpyR_q__copySection",
  "left": "SocialMediaPopover-module-scss-module__cpyR_q__left",
  "linkSharerWrapper": "SocialMediaPopover-module-scss-module__cpyR_q__linkSharerWrapper",
  "popOver": "SocialMediaPopover-module-scss-module__cpyR_q__popOver",
  "popOverFooter": "SocialMediaPopover-module-scss-module__cpyR_q__popOverFooter",
  "popOverHeader": "SocialMediaPopover-module-scss-module__cpyR_q__popOverHeader",
  "popOverWrapper": "SocialMediaPopover-module-scss-module__cpyR_q__popOverWrapper",
  "right": "SocialMediaPopover-module-scss-module__cpyR_q__right",
  "socialMediaIcons": "SocialMediaPopover-module-scss-module__cpyR_q__socialMediaIcons",
  "top": "SocialMediaPopover-module-scss-module__cpyR_q__top",
  "url": "SocialMediaPopover-module-scss-module__cpyR_q__url",
});
